import React from 'react';
import { useCountdown } from './hooks/useCountdown';
import { LogoHeader } from './components/LogoHeader';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { TestimonialsHighlight } from './components/TestimonialsHighlight';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BenefitStrip } from './components/BenefitStrip';
import { ContenidoIncluido } from './components/ContenidoIncluido';
import { BonusesSection } from './components/BonusesSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { TestimonialsExtended } from './components/TestimonialsExtended';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  // Live countdown synced across sections
  const timeLeft = useCountdown(23, 40, 36);
  return <div className="min-h-screen bg-page text-white font-sans" data-id="element-0" data-mp="3mjztd6hzp62c">

      <LogoHeader data-id="element-1" data-mp="3rbzomln47asl" />
      <HeroSection data-id="element-2" data-mp="3rdkg22e4udm8" />
      <SocialProof data-id="element-3" data-mp="3rd18nfm3z7mg" />
      <TestimonialsHighlight data-id="element-4" data-mp="3relwkmdx3sbc" />
      <ProblemSection data-id="element-5" data-mp="67znpl2q47d" />
      <TomosSection data-id="element-6" data-mp="4n6o4eeqtbm" />
      <BonusesSection data-id="element-7" data-mp="56qxrrj5tst" />
      <BenefitStrip data-id="element-8" data-mp="2zl3bdjx5744s" />
      <ContenidoIncluido data-id="element-9" data-mp="2zlld2w2kqak3" />
      <CountdownTimer timeLeft={timeLeft} data-id="element-10" data-mp="2zmenq84nlk7i" />
      <PricingSection data-id="element-11" data-mp="33mouhn09senf" />
      <TestimonialsExtended data-id="element-12" data-mp="33m5ck6amdq9e" />
      <GuaranteeSection data-id="element-13" data-mp="33ngfk3w8qtzg" />
      <FAQSection data-id="element-14" data-mp="33orik1hv3xpi" />
      <FinalCTA timeLeft={timeLeft} data-id="element-15" data-mp="38lrq6gud18iq" />
      <FooterSection data-id="element-16" data-mp="38kqce4lym7xb" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-page/95 backdrop-blur border-t border-white/10 px-3 pt-3 pb-[42px] md:hidden z-50" data-id="element-17" data-mp="3dkuv81acbeqp">
        <a href="https://checkout.prodikit.com/checkout" className="cta-btn block w-full text-white text-center font-display font-extrabold text-base uppercase tracking-wide py-3.5 rounded-full" data-id="element-18" data-mp="nuhg0bzipzr4">
          🍱 QUIERO MI MEGAPACK
        </a>
      </div>
    </div>;
}